"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var socketClient_1 = require("../../../../socket/socketClient");
var state = require("../../../state/state");
var ProvideHover = /** @class */ (function () {
    function ProvideHover() {
    }
    ProvideHover.prototype.provideHover = function (model, pos, token) {
        var filePath = model.filePath;
        if (!state.inActiveProjectFilePath(model.filePath)) {
            return null;
        }
        var position = model.getOffsetAt(pos);
        return socketClient_1.server.quickInfo({
            filePath: filePath,
            position: position
        }).then(function (res) {
            // console.log(res); // DEBUG
            if (!res.valid) {
                return null;
            }
            /** Since we do not show `error` yet just return if no `info` */
            if (!res.info) {
                return null;
            }
            var result = {
                range: {
                    startLineNumber: res.info.range.from.line + 1,
                    startColumn: res.info.range.from.ch + 1,
                    endLineNumber: res.info.range.to.line + 1,
                    endColumn: res.info.range.to.ch + 1,
                },
                contents: [
                    "***" + res.info.name + "***"
                ]
            };
            if (res.info.comment) {
                result.contents.push('\n\n' + res.info.comment);
            }
            return result;
        });
    };
    return ProvideHover;
}());
exports.ProvideHover = ProvideHover;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/monaco/languages/typescript/provideHover.js
 ** module id = 441
 ** module chunks = 0
 **/